module.exports = __webpack_public_path__ + "static/media/sign-in-background.fa82a52e.png";